const ru = {
  lang: {
    caption: "Язык",
    aria: "Сменить язык сайта, сейчас: ",
  },
  a11y: {
    skipToMain: "Перейти к основному содержимому",
  },
  nav: {
    home: "Главная",
    services: "Услуги",
    portfolio: "Портфолио",
    about: "О нас",
    contact: "Контакты",
    cta: "Написать в WhatsApp",
  },
  hero: {
    offer: "Сайты, чат-боты и заявки под ваш бизнес",
    h1a: "Сайт или бот для записи и заявок — ",
    h1b: "под ваш бизнес",
    h2: "Настраиваем приём обращений, заявки с сайта и из WhatsApp, Instagram и Telegram",
    ctaReview: "Получить бесплатную консультацию",
    ctaContact: "Написать в Telegram",
    imgAlt: "Broxe Group — сайты и чат-боты для бизнеса",
  },
  solution: {
    beforeBrand: "Что делает ",
    afterBrand: ": сайты, боты и приём заявок",
    lead:
      "Мы собираем и настраиваем инструменты — страницу, бота, сценарии. Итоговые продажи и выручка зависят от вашего продукта и работы с клиентами; мы отвечаем за техническую часть.",
    l1: "Бот и сайт работают по сценарию, который вы утверждаете: ответы, запись, заявка",
    l2: "Обычно 3–7 дней до запуска готового решения — дальше вы ведёте процесс сами",
    l3: "Запись и заявки в одной цепочке — меньше ручной переписки в чатах",
    ctaConsult: "Получить консультацию",
    quote:
      "Мы не обещаем доход. Делаем рабочие боты, лендинги и связки — как вы их используете, решаете вы.",
  },
  servicesPrev: {
    beforeH: "Инструменты ",
    highlight: "для бизнеса",
    afterH: ": сайт, бот, заявки",
    intro:
      "Лендинги, чат-боты, простые системы для заявок и сценарии под нишу — под конкретную задачу, без лишнего.",
    s1t: "Чат-боты",
    s1d:
      "WhatsApp, Instagram, Telegram: ответ по шаблону, запись, заявка — пока вы заняты делом.",
    s2t: "Заявки и системы",
    s2d:
      "Приём заявок с сайта и из мессенджеров в одном месте — удобнее вам и администратору.",
    s3t: "Сайты",
    s3d:
      "Лендинги под бизнес: быстрый запуск, понятный текст, форма заявки.",
    s4t: "Под вашу нишу",
    s4d:
      "Клиники, детейлинг, салоны, барбершопы, автосервисы — типовые сценарии под ключ.",
    btn: "Смотреть услуги",
  },
  process: {
    beforeH: "Три шага — ",
    highlight: "от задачи к запуску",
    p1t: "Уточняем задачу",
    p1d:
      "Как сейчас принимаете обращения: телефон, чаты, сайт — и что нужно автоматизировать в первую очередь.",
    p2t: "Делаем и запускаем",
    p2d:
      "Сайт, бот или схема заявок — обычно 3–7 дней до готового к использованию варианта.",
    p3t: "Дорабатываем при необходимости",
    p3d:
      "По обратной связи правим тексты и сценарии — пока вам и клиентам будет удобно пользоваться.",
  },
  ctaFinal: {
    title: "Обсудим вашу задачу",
    sub:
      "Бесплатная консультация или короткий созвон: расскажем, что можно подключить и как устроена работа — без обещаний про выручку.",
    req: "Получить консультацию",
    demo: "Написать в Telegram",
  },
  social: {
    title: "Напишите — ответим по услугам",
    or: "или",
    p2: ": город и сфера — подскажем, с чего обычно начинают в похожих кейсах",
  },
  faq: {
    title: "Частые вопросы",
    subtitle: "Сайты, боты и заявки — что спрашивают чаще всего",
    items: [
      {
        q: "Сколько занимает первый запуск?",
        a: "Обычно 3–7 рабочих дней до рабочей схемы: сайт, бот или приём заявок. Потом при необходимости дорабатываем по вашим замечаниям.",
      },
      {
        q: "Нужно ли сразу увеличивать рекламу?",
        a: "Не обязательно. Сначала можно настроить приём тех, кто уже пишет: ответы, запись, форма на сайте. Рекламу подключают отдельно, когда процесс устроен.",
      },
      {
        q: "Кому подходит?",
        a: "Детейлинг, клиники, салоны, барбершопы, автосервисы, локальный бизнес, магазины в Instagram — если нужны заявки и запись из интернета и мессенджеров.",
      },
      {
        q: "Только WhatsApp и Telegram?",
        a: "Нет. WhatsApp, Instagram, Telegram — как договоримся. Настраиваем так, чтобы клиент мог оставить заявку или записаться без лишних шагов.",
      },
      {
        q: "С чего начать?",
        a: "Напишите нишу, город и основной канал (например WhatsApp). Кнопки на сайте ведут в мессенджеры — можно запросить консультацию.",
      },
      {
        q: "Как считается стоимость?",
        a: "От объёма: каналы, нужен ли сайт, глубина сценария бота. Делаем по задаче, без навязанных пакетов.",
      },
    ],
  },
  aboutPage: {
    h1a: "Кто мы и ",
    h1b: "чем занимаемся",
    imgAlt: "Broxe Group — сайты, чат-боты и заявки для бизнеса",
  },
  aboutCard: {
    p1rest:
      "делает под заказ лендинги, чат-боты в WhatsApp, Instagram и Telegram, простые системы для заявок и готовые сценарии для салонов, клиник, детейлинга, автосервисов и магазинов в соцсетях. Важно удобное решение под задачу, а не «слайды для инвесторов».",
    p2:
      "Сайт и бот — это инструменты: по ним клиент может записаться или оставить заявку. Как вы дальше работаете с обращениями — на вашей стороне.",
    li1: "Понятные инструменты — сайт, бот, заявки — без лишнего про «имидж»",
    li2: "Настраиваем ответы и запись по вашим правилам и графику",
    li3: "Сроки в днях, не в кварталах — быстро запускаем и правим по обратной связи",
    quote: "Мы не подменяем собой ваш маркетинг — даём рабочие боты и страницы.",
  },
  servicesPage: {
    h1a: "Что мы делаем ",
    h1b: "для бизнеса",
    p1:
      "Подбираем связку под задачу: сайт, бот, формы заявок, интеграции — что вы запросили.",
    p2:
      "Сроки старта работ обычно 3–7 дней; точные сроки скажем после короткого обсуждения.",
  },
  servicesDetail: {
    chatbot: {
      title: "Чат-боты",
      bullets: [
        "WhatsApp, Instagram, Telegram — сценарии ответов, запись, заявка",
        "Меньше однотипных сообщений вручную — бот ведёт по шагам",
        "Один сценарий на канал — проще поддерживать",
      ],
    },
    automation: {
      title: "Заявки и простые системы",
      bullets: [
        "Заявки с сайта и из мессенджеров в одном месте",
        "Таблица или лёгкая CRM — по желанию, без перегруза",
        "Меньше ручного копирования контактов",
      ],
    },
    sites: {
      title: "Сайты и лендинги",
      bullets: [
        "Лендинг с понятным действием: написать, позвонить, оставить заявку",
        "Быстрый запуск — можно потом менять тексты",
        "Верстка под мобильные экраны",
      ],
    },
    content: {
      title: "Решения под нишу",
      bullets: [
        "Клиники, детейлинг, салоны, барбершопы, автосервисы — стартовые шаблоны под формат",
        "Прайс, адрес, услуги, запись — собираем под ваш список",
        "Дальше — точечные правки под акции и изменения",
      ],
    },
  },
  contact: {
    h1a: "Напишите — ",
    h1b: "обсудим задачу",
    intro:
      "WhatsApp или Telegram — ответим и расскажем, что можем подключить. Ниже прямые ссылки.",
    waPrefillReview:
      "Здравствуйте! Хочу бесплатную консультацию по сайту и заявкам для бизнеса (Broxe Group).",
    waPrefillConsult:
      "Здравствуйте! Нужна консультация: сайт, чат-бот или заявки для бизнеса (Broxe Group).",
    waPrefillDemo:
      "Здравствуйте! Хочу обсудить сайт или бота для бизнеса (Broxe Group).",
    waPrefillNav: "Здравствуйте! Хочу связаться с Broxe Group.",
    tgPrefillContact: "Здравствуйте! Пишу с сайта Broxe Group, хочу обсудить заявки и сайт.",
    tgPrefillDemo:
      "Здравствуйте! Хочу обсудить сайт или бота для бизнеса (Broxe Group).",
  },
  leadForm: {
    name: "Имя",
    phone: "Телефон или Telegram",
    phName: "Как к вам обратиться",
    phPhone: "+7 … или @username",
    alert:
      "Заявка принята. Напишем или позвоним — уточним задачу: сайт, бот или приём заявок.",
    submitDefault: "Оставить заявку",
    submitConsult: "Получить консультацию",
  },
  serviceCard: {
    demo: "Написать в WhatsApp",
  },
  footer: {
    tagline:
      "Сайты и чат-боты под задачу бизнеса. Инструменты — в ваших руках.",
    ariaWa: "WhatsApp Broxe Group",
    ariaTg: "Telegram Broxe Group",
  },
  homeAria: {
    wa: "Написать в WhatsApp Broxe Group",
    tg: "Написать в Telegram Broxe Group",
  },
  portfolio: {
    sectionTitle: "Избранные работы",
    sectionSubtitle: "Отдельные проекты: интерфейсы, страницы и демо-видео.",
    viewAll: "Смотреть все проекты",
    pageTitle: "Портфолио — все проекты",
    pageSubtitle:
      "Галереи открываются по клику на полный размер; видео можно смотреть прямо на странице. Файлы берутся из папки portfolio.",
    badgeGallery: "Скриншоты",
    badgeVideo: "Видео",
    copyLink: "Скопировать ссылку",
    linkCopied: "Скопировано",
    items: {
      adminPanel: {
        title: "Админ-панель",
        desc: "Экраны панели управления.",
      },
      lardiTrans: {
        title: "Lardi-Trans",
        desc: "Страницы и сценарии в интерфейсе.",
      },
      regemsal: {
        title: "Regemsal",
        desc: "Основные экраны проекта.",
      },
      tutAz: {
        title: "Tut.az",
        desc: "Главная и карточка товара.",
      },
      projectManager: {
        title: "Менеджер проектов",
        desc: "Фрагменты интерфейса продукта.",
      },
      jsdelivr: {
        title: "Статистика jsDelivr",
        desc: "Сеть и статистика.",
      },
      lg2: {
        title: "Проект (lg2)",
        desc: "Варианты главной страницы.",
      },
      podriadchik: {
        title: "Платформа подрядчика",
        desc: "Маркетплейс, компании, чат.",
      },
      apiBoost: {
        title: "API Boost",
        desc: "Экраны и сценарии интерфейса.",
      },
      alivaria: {
        title: "Alivaria",
        desc: "Страницы и элементы проекта.",
      },
      belInter: {
        title: "Bel Inter",
        desc: "Фрагменты интерфейса.",
      },
      bitcoinEmpire: {
        title: "Bitcoin Empire",
        desc: "Экраны приложения.",
      },
      tringleSpace: {
        title: "Tringle Space",
        desc: "Интерфейс и основные экраны.",
      },
      espireo: {
        title: "Espireo",
        desc: "Основные экраны проекта.",
      },
      huskyHelp: {
        title: "Husky Help",
        desc: "Страницы и пользовательские сценарии.",
      },
      presentashki: {
        title: "Presentashki",
        desc: "Примеры экранов и макетов.",
      },
      video: {
        desc: "Короткое видео по проекту.",
      },
      v0074: { title: "Видео-демо 11" },
      v0076: { title: "Видео-демо 1" },
      v0081: { title: "Видео-демо 2" },
      v0082: { title: "Видео-демо 3" },
      v0083: { title: "Видео-демо 4" },
      v0088: { title: "Видео-демо 6" },
      v0089: { title: "Видео-демо 7" },
      v0091: { title: "Видео-демо 8" },
      v0092: { title: "Видео-демо 5" },
      v0094: { title: "Видео-демо 9" },
      v0095: { title: "Видео-демо 10" },
    },
  },
  seo: {
    siteName: "Broxe Group",
    ogImageAlt: "Broxe Group — сайты и чат-боты для бизнеса",
    keywords:
      "лендинг, сайт для бизнеса, чат-бот WhatsApp, чат-бот Instagram, чат-бот Telegram, заявки с сайта, запись онлайн, детейлинг, клиника, салон красоты, барбершоп, автосервис, магазин Instagram",
    home: {
      title: "Broxe Group — сайты и чат-боты для бизнеса",
      description:
        "Разработка лендингов, чат-ботов в WhatsApp, Instagram и Telegram, приём заявок, решения под нишу. Детейлинг, клиники, салоны, локальный бизнес. Пишите в WhatsApp или Telegram.",
    },
    services: {
      title: "Услуги Broxe Group — сайты, чат-боты, заявки",
      description:
        "Чат-боты для мессенджеров, лендинги, простые системы для заявок, сценарии для салонов, клиник, детейлинга и магазинов. Обсудим задачу и подберём формат.",
    },
    about: {
      title: "О Broxe Group — сайты и боты для малого и локального бизнеса",
      description:
        "Broxe Group: лендинги, боты, приём заявок. Салоны, клиники, детейлинг, автосервисы, магазины в соцсетях.",
    },
    contact: {
      title: "Контакты Broxe Group — WhatsApp и Telegram",
      description:
        "Свяжитесь с Broxe Group в WhatsApp или Telegram: вопросы по сайту, боту и заявкам.",
    },
    portfolio: {
      title: "Портфолио Broxe Group — примеры работ и демо-видео",
      description:
        "Примеры работ: интерфейсы, страницы, демонстрации. Все материалы на одной странице.",
    },
  },
};

export default ru;
